export const PRICING_PLANS = {
  bronze: {
    name: "Bronze",
    color: "brand-color",
    key: {
      monthly: "paddle_bronze_monthly",
      yearly: "paddle_bronze_yearly",
    },
    pricing: {
      monthly: 29,
      yearly: 24,
    },
    cardText: [
      "20 Forms",
      "500 Submissions/month",
      "1GB Storage",
      "1 Landing Page",
      "2 AI Generations/month",
      "Standard Support",
      { label: "Electronic signature", included: false },
    ],
    comparison: {
      // CORE FEATURES
      forms: {
        label: "Forms",
        limit: "20",
        tooltip: "Total number of forms you can create and manage forever",
        category: "core",
        icon: "mdi-form-select",
      },
      leads: {
        label: "Submissions/month",
        limit: "500",
        tooltip:
          "Monthly limit that resets each month. Includes both complete and partial form submissions",
        category: "core",
        icon: "mdi-account-plus",
      },
      views: {
        label: "Views/month",
        limit: "Unlimited",
        category: "core",
        icon: "mdi-eye",
      },
      questions: {
        label: "Questions/forms",
        limit: "Unlimited",
        category: "core",
        icon: "mdi-help-circle",
      },
      storage: {
        label: "Storage",
        limit: "1GB",
        tooltip: "Lifetime storage space for files and media uploads",
        category: "core",
        icon: "mdi-harddisk",
      },
      landingPages: {
        label: "Landing Pages",
        limit: "1",
        tooltip:
          "Total number of landing pages you can create and keep forever",
        category: "core",
        icon: "mdi-web",
      },
      aiGeneration: {
        label: "AI Generation",
        limit: "2",
        tooltip:
          "Monthly AI generations that reset each month. Use AI to create and optimize your landing pages automatically",
        category: "core",
        icon: "mdi-robot",
      },
      electronicSignature: {
        label: "Electronic signature",
        limit: false,
        tooltip:
          "Request secure electronic signatures with audit trail and signed PDFs stored with your submissions",
        category: "core",
        icon: "mdi-signature",
      },

      // FORM BUILDER & CUSTOMIZATION
      multipleFormEndings: {
        label: "Multiple form endings",
        limit: true,
        category: "form-builder",
        icon: "mdi-format-list-bulleted",
      },
      thankYouMessageEditor: {
        label: "Thank you message editor",
        limit: true,
        category: "form-builder",
        icon: "mdi-message-text",
      },
      postFormDataToUrl: {
        label: "Post/append form data to URL",
        limit: true,
        category: "form-builder",
        icon: "mdi-link",
      },
      redirectToUrl: {
        label: "Redirect to URL",
        limit: true,
        category: "form-builder",
        icon: "mdi-redirect",
      },
      utmParameters: {
        label: "UTM Parameters",
        limit: true,
        category: "form-builder",
        icon: "mdi-tag",
      },
      conditionalLogicFlows: {
        label: "Conditional logic flows",
        limit: true,
        category: "form-builder",
        icon: "mdi-flowchart",
      },
      calculatorForms: {
        label: "Calculator forms/ lead scoring",
        limit: true,
        category: "form-builder",
        icon: "mdi-calculator",
      },
      addressAutocomplete: {
        label: "Address Autocomplete",
        limit: true,
        category: "form-builder",
        icon: "mdi-map-marker",
      },
      addTrackingScripts: {
        label: "Add tracking scripts",
        limit: true,
        category: "form-builder",
        icon: "mdi-code-tags",
      },
      hiddenFields: {
        label: "Hidden fields",
        limit: true,
        category: "form-builder",
        icon: "mdi-eye-off",
      },
      premiumThemes: {
        label: "Premium themes",
        limit: true,
        category: "form-builder",
        icon: "mdi-palette",
      },
      formVisibilityGeoFencing: {
        label: "Form visibility geo-fencing",
        limit: true,
        tooltip:
          "Block forms based on visitor location and geographic restrictions",
        category: "form-builder",
        icon: "mdi-earth",
      },
      customEmailValidation: {
        label: "Custom email validation",
        limit: true,
        category: "form-builder",
        icon: "mdi-email-check",
      },
      leadproofPopups: {
        label: "Leadproof popups",
        limit: true,
        category: "form-builder",
        icon: "mdi-popcorn",
      },

      // INTEGRATIONS
      contactStateIntegration: {
        label: "Contact State integration",
        limit: true,
        category: "integrations",
        icon: "mdi-account-network",
      },
      trustedformIntegration: {
        label: "Trustedform integration",
        limit: true,
        category: "integrations",
        icon: "mdi-shield-check",
      },
      zapierIntegration: {
        label: "Zapier integration",
        limit: true,
        category: "integrations",
        icon: "mdi-zap",
      },
      webhooksIntegration: {
        label: "Webhooks integration",
        limit: true,
        category: "integrations",
        icon: "mdi-webhook",
      },
      googleAnalyticsIntegration: {
        label: "Google analytics integration",
        limit: true,
        category: "integrations",
        icon: "mdi-chart-line",
      },

      // NOTIFICATIONS
      emailSelfNotifications: {
        label: "Email Notifications",
        limit: true,
        category: "notifications",
        icon: "mdi-email",
      },

      // SUPPORT
      support: {
        label: "Support",
        limit: "Standard",
        tooltip:
          "Standard email support with 24 hour response time for general inquiries",
        category: "support",
        icon: "mdi-headset",
      },
    },
  },
  silver: {
    name: "Silver",
    color: "brand-color",
    key: {
      monthly: "paddle_silver_monthly",
      yearly: "paddle_silver_yearly",
    },
    pricing: {
      monthly: 59,
      yearly: 49,
    },
    cardText: [
      "200 Forms",
      "5,000 Submissions/month",
      "5GB Storage",
      "5 Landing Pages",
      "7 AI Generations/month",
      "Priority Support",
      { label: "Electronic signature", included: true },
    ],
    comparison: {
      // CORE FEATURES
      forms: {
        label: "Forms",
        limit: "200",
        tooltip: "Total number of forms you can create and manage forever",
        category: "core",
        icon: "mdi-form-select",
      },
      leads: {
        label: "Submissions/month",
        limit: "5,000",
        tooltip:
          "Monthly limit that resets each month. Includes both complete and partial form submissions",
        category: "core",
        icon: "mdi-account-plus",
      },
      views: {
        label: "Views/month",
        limit: "Unlimited",
        category: "core",
        icon: "mdi-eye",
      },
      questions: {
        label: "Questions/forms",
        limit: "Unlimited",
        category: "core",
        icon: "mdi-help-circle",
      },
      storage: {
        label: "Storage",
        limit: "5GB",
        tooltip: "Lifetime storage space for files and media uploads",
        category: "core",
        icon: "mdi-harddisk",
      },
      landingPages: {
        label: "Landing Pages",
        limit: "5",
        tooltip:
          "Total number of landing pages you can create and keep forever",
        category: "core",
        icon: "mdi-web",
      },
      aiGeneration: {
        label: "AI Generation",
        limit: "10",
        tooltip:
          "Monthly AI generations that reset each month. Use AI to create and optimize your landing pages automatically",
        category: "core",
        icon: "mdi-robot",
      },
      electronicSignature: {
        label: "Electronic signature",
        limit: true,
        tooltip:
          "Request secure electronic signatures with audit trail and signed PDFs stored with your submissions",
        category: "core",
        icon: "mdi-signature",
      },

      // FORM BUILDER & CUSTOMIZATION
      multipleFormEndings: {
        label: "Multiple form endings",
        limit: true,
        category: "form-builder",
        icon: "mdi-format-list-bulleted",
      },
      thankYouMessageEditor: {
        label: "Thank you message editor",
        limit: true,
        category: "form-builder",
        icon: "mdi-message-text",
      },
      postFormDataToUrl: {
        label: "Post/append form data to URL",
        limit: true,
        category: "form-builder",
        icon: "mdi-link",
      },
      redirectToUrl: {
        label: "Redirect to URL",
        limit: true,
        category: "form-builder",
        icon: "mdi-redirect",
      },
      utmParameters: {
        label: "UTM Parameters",
        limit: true,
        category: "form-builder",
        icon: "mdi-tag",
      },
      conditionalLogicFlows: {
        label: "Conditional logic flows",
        limit: true,
        category: "form-builder",
        icon: "mdi-flowchart",
      },
      calculatorForms: {
        label: "Calculator forms/ lead scoring",
        limit: true,
        category: "form-builder",
        icon: "mdi-calculator",
      },
      addressAutocomplete: {
        label: "Address Autocomplete",
        limit: true,
        category: "form-builder",
        icon: "mdi-map-marker",
      },
      addTrackingScripts: {
        label: "Add tracking scripts",
        limit: true,
        category: "form-builder",
        icon: "mdi-code-tags",
      },
      hiddenFields: {
        label: "Hidden fields",
        limit: true,
        category: "form-builder",
        icon: "mdi-eye-off",
      },
      premiumThemes: {
        label: "Premium themes",
        limit: true,
        category: "form-builder",
        icon: "mdi-palette",
      },
      formVisibilityGeoFencing: {
        label: "Form visibility geo-fencing",
        limit: true,
        tooltip:
          "Block forms based on visitor location and geographic restrictions",
        category: "form-builder",
        icon: "mdi-earth",
      },
      customEmailValidation: {
        label: "Custom email validation",
        limit: true,
        category: "form-builder",
        icon: "mdi-email-check",
      },
      leadproofPopups: {
        label: "Leadproof popups",
        limit: true,
        category: "form-builder",
        icon: "mdi-popcorn",
      },

      // INTEGRATIONS
      contactStateIntegration: {
        label: "Contact State integration",
        limit: true,
        category: "integrations",
        icon: "mdi-account-network",
      },
      trustedformIntegration: {
        label: "Trustedform integration",
        limit: true,
        category: "integrations",
        icon: "mdi-shield-check",
      },
      zapierIntegration: {
        label: "Zapier integration",
        limit: true,
        category: "integrations",
        icon: "mdi-zap",
      },
      webhooksIntegration: {
        label: "Webhooks integration",
        limit: true,
        category: "integrations",
        icon: "mdi-webhook",
      },
      googleAnalyticsIntegration: {
        label: "Google analytics integration",
        limit: true,
        category: "integrations",
        icon: "mdi-chart-line",
      },

      // NOTIFICATIONS
      emailSelfNotifications: {
        label: "Email Notifications",
        limit: true,
        category: "notifications",
        icon: "mdi-email",
      },

      // SUPPORT
      support: {
        label: "Support",
        limit: "Priority",
        tooltip:
          "Priority email support with 8-16 hour response time and faster resolution for urgent issues",
        category: "support",
        icon: "mdi-headset",
      },
    },
  },
  gold: {
    name: "Gold",
    color: "brand-color",
    key: {
      monthly: "paddle_gold_monthly",
      yearly: "paddle_gold_yearly",
    },
    pricing: {
      monthly: 99,
      yearly: 83,
    },
    cardText: [
      "500 Forms",
      "15,000 Submissions/month",
      "20GB Storage",
      "25 Landing Pages",
      "30 AI Generations/month",
      "Dedicated Support Manager",
      { label: "Electronic signature", included: true },
    ],
    comparison: {
      forms: {
        label: "Forms",
        limit: "500",
        tooltip: "Total number of forms you can create and manage forever",
      },
      leads: {
        label: "Submissions/month",
        limit: "15,000",
        tooltip:
          "Monthly limit that resets each month. Includes both complete and partial form submissions",
      },
      views: { label: "Views/month", limit: "Unlimited" },
      questions: { label: "Questions/forms", limit: "Unlimited" },
      storage: {
        label: "Storage",
        limit: "20GB",
        tooltip: "Lifetime storage space for files and media uploads",
      },
      landingPages: {
        label: "Landing Pages",
        limit: "25",
        tooltip:
          "Total number of landing pages you can create and keep forever",
      },
      aiGeneration: {
        label: "AI Generation",
        limit: "50",
        tooltip:
          "Monthly AI generations that reset each month. Use AI to create and optimize your landing pages automatically",
      },
      electronicSignature: {
        label: "Electronic signature",
        limit: true,
        tooltip:
          "Request secure electronic signatures with audit trail and signed PDFs stored with your submissions",
        category: "core",
        icon: "mdi-signature",
      },
      multipleFormEndings: { label: "Multiple form endings", limit: true },
      thankYouMessageEditor: { label: "Thank you message editor", limit: true },
      postFormDataToUrl: { label: "Post/append form data to URL", limit: true },
      redirectToUrl: { label: "Redirect to URL", limit: true },
      utmParameters: { label: "UTM Parameters", limit: true },
      contactStateIntegration: {
        label: "Contact State integration",
        limit: true,
      },
      trustedformIntegration: { label: "Trustedform integration", limit: true },
      zapierIntegration: { label: "Zapier integration", limit: true },
      webhooksIntegration: { label: "Webhooks integration", limit: true },
      googleAnalyticsIntegration: {
        label: "Google analytics integration",
        limit: true,
      },
      conditionalLogicFlows: { label: "Conditional logic flows", limit: true },
      calculatorForms: { label: "Calculator forms/ lead scoring", limit: true },
      addressAutocomplete: { label: "Address Autocomplete", limit: true },
      addTrackingScripts: { label: "Add tracking scripts", limit: true },
      hiddenFields: { label: "Hidden fields", limit: true },
      premiumThemes: { label: "Premium themes", limit: true },
      formVisibilityGeoFencing: {
        label: "Form visibility geo-fencing",
        limit: true,
        tooltip:
          "Block forms based on visitor location and geographic restrictions",
      },
      customEmailValidation: { label: "Custom email validation", limit: true },
      leadproofPopups: { label: "Leadproof popups", limit: true },
      emailSelfNotifications: {
        label: "Email Notifications",
        limit: true,
      },
      support: {
        label: "Support",
        limit: "Dedicated",
        tooltip:
          "Dedicated support manager with direct contact, same-day response time, and personalized assistance",
      },
    },
  },
  platinum: {
    name: "Platinum",
    color: "brand-color",
    key: {
      monthly: "paddle_platinum_monthly",
      yearly: "paddle_platinum_yearly",
    },
    pricing: {
      monthly: 199,
      yearly: 169,
    },
    cardText: [
      "1,500 Forms",
      "30,000 Submissions/month",
      "50GB Storage",
      "35 Landing Pages",
      "45 AI Generations/month",
      "Dedicated Support Manager",
      { label: "Electronic signature", included: true },
    ],
    comparison: {
      forms: {
        label: "Forms",
        limit: "1,500",
        tooltip: "Total number of forms you can create and manage forever",
      },
      leads: {
        label: "Submissions/month",
        limit: "30,000",
        tooltip:
          "Monthly limit that resets each month. Includes both complete and partial form submissions",
      },
      views: { label: "Views/month", limit: "Unlimited" },
      questions: { label: "Questions/forms", limit: "Unlimited" },
      storage: {
        label: "Storage",
        limit: "50GB",
        tooltip: "Lifetime storage space for files and media uploads",
      },
      landingPages: {
        label: "Landing Pages",
        limit: "35",
        tooltip:
          "Total number of landing pages you can create and keep forever",
      },
      aiGeneration: {
        label: "AI Generation",
        limit: "70",
        tooltip:
          "Monthly AI generations that reset each month. Use AI to create and optimize your landing pages automatically",
      },
      electronicSignature: {
        label: "Electronic signature",
        limit: true,
        tooltip:
          "Request secure electronic signatures with audit trail and signed PDFs stored with your submissions",
        category: "core",
        icon: "mdi-signature",
      },
      multipleFormEndings: { label: "Multiple form endings", limit: true },
      thankYouMessageEditor: { label: "Thank you message editor", limit: true },
      postFormDataToUrl: { label: "Post/append form data to URL", limit: true },
      redirectToUrl: { label: "Redirect to URL", limit: true },
      utmParameters: { label: "UTM Parameters", limit: true },
      contactStateIntegration: {
        label: "Contact State integration",
        limit: true,
      },
      trustedformIntegration: { label: "Trustedform integration", limit: true },
      zapierIntegration: { label: "Zapier integration", limit: true },
      webhooksIntegration: { label: "Webhooks integration", limit: true },
      googleAnalyticsIntegration: {
        label: "Google analytics integration",
        limit: true,
      },
      conditionalLogicFlows: { label: "Conditional logic flows", limit: true },
      calculatorForms: { label: "Calculator forms/ lead scoring", limit: true },
      addressAutocomplete: { label: "Address Autocomplete", limit: true },
      addTrackingScripts: { label: "Add tracking scripts", limit: true },
      hiddenFields: { label: "Hidden fields", limit: true },
      premiumThemes: { label: "Premium themes", limit: true },
      formVisibilityGeoFencing: {
        label: "Form visibility geo-fencing",
        limit: true,
        tooltip:
          "Block forms based on visitor location and geographic restrictions",
      },
      customEmailValidation: { label: "Custom email validation", limit: true },
      leadproofPopups: { label: "Leadproof popups", limit: true },
      emailSelfNotifications: {
        label: "Email Notifications",
        limit: true,
      },
      support: {
        label: "Support",
        limit: "Dedicated",
        tooltip:
          "Dedicated support manager with direct contact, same-day response time, and personalized assistance",
      },
    },
  },
  // Legacy plans (not rendered as cards, used for helper functions)
  starter: {
    name: "Starter",
    color: "outline-color",
    key: {
      monthly: "paddle_starter",
      yearly: null,
    },
    pricing: {
      monthly: 19,
      yearly: null,
    },
  },
  pro: {
    name: "Pro",
    color: "outline-color",
    key: {
      monthly: "paddle_pro",
      yearly: "paddle_pro_annual",
    },
    pricing: {
      monthly: 49,
      yearly: 39,
    },
  },
  scale: {
    name: "Scale",
    color: "outline-color",
    key: {
      monthly: "paddle_scale",
      yearly: "paddle_scale_annual",
    },
    pricing: {
      monthly: 99,
      yearly: 79,
    },
  },
  enterprise: {
    name: "Enterprise",
    color: "outline-color",
    key: {
      monthly: "paddle_enterprise",
      yearly: "paddle_enterprise_annual",
    },
    pricing: {
      monthly: 250,
      yearly: 200,
    },
  },
  single: {
    name: "Single",
    color: "outline-color",
    key: {
      monthly: null,
      yearly: "paddle_single_annual",
    },
    pricing: {
      monthly: null,
      yearly: 50,
    },
  },
};

// Plan order for display (only new plans, legacy plans not included)
export const PLAN_ORDER = ["bronze", "silver", "gold"];

// Most popular plan
export const MOST_POPULAR_PLAN = "silver";

// Feature categories with icons and labels
export const FEATURE_CATEGORIES = {
  core: {
    label: "Core Features",
    icon: "mdi-cog",
    description: "Essential features and limits",
  },
  "form-builder": {
    label: "Form Builder & Customization",
    icon: "mdi-form-select",
    description: "Advanced form building and customization options",
  },
  integrations: {
    label: "Integrations",
    icon: "mdi-puzzle",
    description: "Third-party service integrations",
  },
  notifications: {
    label: "Notifications",
    icon: "mdi-bell",
    description: "Email and notification settings",
  },
  support: {
    label: "Support",
    icon: "mdi-headset",
    description: "Customer support options",
  },
};

// Helper function to get features by category
export const getFeaturesByCategory = (planKey, category) => {
  const plan = PRICING_PLANS[planKey];
  if (!plan) return [];

  return Object.entries(plan.comparison)
    .filter(([key, feature]) => feature.category === category)
    .map(([key, feature]) => ({ key, ...feature }));
};

// Helper function to get all categories for a plan
export const getPlanCategories = (planKey) => {
  const plan = PRICING_PLANS[planKey];
  if (!plan) return [];

  const categories = new Set();
  Object.values(plan.comparison).forEach((feature) => {
    if (feature.category) {
      categories.add(feature.category);
    }
  });

  return Array.from(categories).map((category) => ({
    key: category,
    ...FEATURE_CATEGORIES[category],
  }));
};

// Billing cycles
export const BILLING_CYCLES = Object.freeze({
  MONTHLY: { key: "monthly", interval: "month", suffix: "_monthly" },
  YEARLY: { key: "yearly", interval: "year", suffix: "_yearly" },
});

// Dialog modes
export const DIALOG_MODES = Object.freeze({
  CHOOSE: "choose",
  MANAGE: "manage",
});

// Subscription status
export const SUBSCRIPTION_STATUS = {
  ACTIVE: "active",
  PAUSED: "paused",
  DELETED: "deleted",
  PAST_DUE: "past_due",
  NONE: "none",
};

// Loader states
export const LOADER_STATES = {
  SUBSCRIBE: "subscribe",
  PAUSE: "pause",
  RESUME: "resume",
  CANCEL: "cancel",
  UPGRADE: "upgrade",
  DOWNGRADE: "downgrade",
  CHANGE: "change",
  BILLING: "billing",
};

// Confirmation dialog action types
export const CONFIRM_ACTION_TYPES = Object.freeze({
  PAUSE: "pause",
  CANCEL: "cancel",
  RESUME: "resume",
  CHANGE: "change",
});

// Other reason constant
export const OTHER_REASON = "Other reason";

// Pause/Cancel subscription reasons
export const PAUSE_CANCEL_REASONS = Object.freeze([
  "Too expensive / Can't afford it right now",
  "Not using the app enough",
  "Missing features I need",
  "Found a better alternative",
  "Technical issues or bugs",
  "Don't need it anymore / Achieved my goal",
  "Taking a temporary break (plan to return)",
  "Too complicated or hard to use",
  "Privacy or data concerns",
  OTHER_REASON,
]);

// Action dialog types (used in PActionDialog component)
export const ACTION_DIALOG_TYPES = {
  TRIAL_ENDED: "trialEnded",
  ACCOUNT_EXPIRED: "accountExpired",
  PAST_DUE: "pastDue",
};
